export { default } from './EcdChip';
